import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import HeaderPresencaBatismo from "./header";
import TabelaPresencaBatismo from "./tabela";


interface ContainerPresencaBatismoProps {

}

const ContainerPresencaBatismo: FunctionComponent<ContainerPresencaBatismoProps> = () => {
  return ( <>
<Container>
  <HeaderPresencaBatismo />
  <TabelaPresencaBatismo/>
</Container>
  </> );
}

export default ContainerPresencaBatismo;
